import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';

interface Props {
  assignId: string;
  userId: string;
}

export default function useFormBuilderScores({ assignId, userId }: Props) {
  const url = `/form-builder/forms/${userId}/${assignId}/scores`;
  const { request } = useAuth();

  const { data: scores, refetch: refetchScores } = useQuery(url, () => request.get(url).then((r) => r.data), {
    enabled: !!userId && !!assignId
  });

  return { scores, refetchScores };
}
